import { IError, IResponseEvent } from "@core/data-access/model";
import { IUserDataService } from "./i-user-data-service";
import { PageObjectTreeService } from "@modules/basic/page/page-object-tree.service";
import { envConfig } from "@env/env-config";
import { UserPreferences } from "@modules/basic/page/page-object-tree";
import { IUserData, IUserDataProxy } from "@modules/user/rest/data/user-data-proxy";
import { LocalStorageKeyEnum } from "@modules/main/LocalStorageKeyEnum";


/**
 * TODO: languageCode变化，region也需要进行变化
 */
export class UserDataService implements IUserDataService {

    public static $inject: Array<string> = ["$q", "userDataProxy", "$objectTree"];

    private isRequestPending: boolean = false;

    private requestQueue: Array<angular.IDeferred<UserPreferences>> = [];

    private userPreferences: IUserData;

    constructor(
        public $q: angular.IQService,
        public userDataProxy: IUserDataProxy,
        public $objectTree: PageObjectTreeService,
    ) {
        let cartNumber: number = this.$objectTree.getCache(LocalStorageKeyEnum.CART_NUMBER) ? Number(this.$objectTree.getCache(LocalStorageKeyEnum.CART_NUMBER)) : 0;

        this.userPreferences = {
            currencyCode: this.$objectTree.getCache(LocalStorageKeyEnum.CURRENCY_CODE) || envConfig.defaultCurrency(),
            cartNumber: cartNumber,
            // languageCode: "",
        };
    }

    getUserDataWithoutCache(): angular.IPromise<IUserData> {
        let defer = this.$q.defer<IUserData>();

        if (this.isRequestPending) {
            this.requestQueue.push(defer);
            return defer.promise;
        }

        // 如果没有进行中的请求，设置状态
        this.isRequestPending = true;

        this.userDataProxy.get().then(res => {
            if (res.success) {
                let userData = res.data;

                this.userPreferences = {
                    currencyCode: userData.currency.code,
                    cartNumber: userData.cartItemsQty
                    // languageCode: "en"
                }

                this.$objectTree.setCache(LocalStorageKeyEnum.CURRENCY_CODE, this.userPreferences.currencyCode);
                this.$objectTree.setCache(LocalStorageKeyEnum.CART_NUMBER, String(this.userPreferences.cartNumber));
                // this.$objectTree.setCache("languageCode", this.userPreferences.languageCode);

                defer.resolve(this.userPreferences);

                while (this.requestQueue.length > 0) {
                    const queuedRequest = this.requestQueue.pop();
                    queuedRequest && queuedRequest.resolve(this.userPreferences);
                }
            }
        }).catch((error) => {
            // 遍历调用队列里的defer

            // 清空队列

            // 错误则返回网站默认货币，默认语言
            // 返回购物车数量为0
            let userPreferences: IUserData = {
                currencyCode: envConfig.defaultCurrency(),
                cartNumber: 0
                // languageCode: appConfig.DEFAULT_LANGUAGE
            }

            defer.resolve(userPreferences);

            while (this.requestQueue.length > 0) {
                const queuedRequest = this.requestQueue.pop();
                queuedRequest && queuedRequest.resolve(userPreferences);
            }
        }).finally(() => {
            this.isRequestPending = false;
        })

        return defer.promise;
    }

    getUserData(): angular.IPromise<IUserData> {
        let currencyCode = this.$objectTree.getCache(LocalStorageKeyEnum.CURRENCY_CODE);
        let cartNumber = this.$objectTree.getCache(LocalStorageKeyEnum.CART_NUMBER);
        // let languageCode = this.$objectTree.getCache("languageCode");

        let defer = this.$q.defer<IUserData>();
        // 如果状态为true，不直接执行defer放到队列里

        // || cartNumber != null || languageCode != null
        if (currencyCode != null) {
            let userPreferences: IUserData = {
                currencyCode: currencyCode,
                cartNumber: Number(cartNumber)
                // languageCode: languageCode
            }
            defer.resolve(userPreferences);
            return defer.promise;
        }

        return this.getUserDataWithoutCache();
    }

    updateUserPreference<T extends IError>(userPreferences: UserPreferences): angular.IPromise<boolean | IResponseEvent<T>> {
        let defer = this.$q.defer<boolean | IResponseEvent<T>>();

        if (userPreferences) {
            this.userDataProxy.updateUserPreferences(userPreferences).then(res => {
                if (res.success) {
                    defer.resolve(true);

                    this.$objectTree.setCache(LocalStorageKeyEnum.CURRENCY_CODE, userPreferences.currencyCode);
                    // this.$objectTree.setCache("languageCode", userPreferences.languageCode);
                }
            }, error => {
                defer.reject(error);
            })
        } else {
            defer.reject(false);
        }

        return defer.promise;
    }

}